import { defineStore } from 'pinia'

export const useInviteModalStore = defineStore('inviteModalStore', () => {
  const isOpenInviteModal = ref(false)
  const openInviteModal = () => {
    isOpenInviteModal.value = true
  }
  const closeInviteModal = () => {
    isOpenInviteModal.value = false
  }

  return {
    isOpenInviteModal,
    openInviteModal,
    closeInviteModal
  }
})
